import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Identifiants invalides");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-ink px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <span className="w-11 h-11 rounded-2xl bg-brand text-white grid place-items-center font-heading font-extrabold text-xl">M</span>
          <span className="font-heading font-extrabold text-2xl text-brand">MobiRider Admin</span>
        </div>
        <h1 className="font-heading font-bold text-2xl text-ink mb-6 flex items-center gap-2"><Lock className="w-6 h-6 text-brand" /> Connexion</h1>
        <label className="block text-base font-semibold text-ink mb-2">Email</label>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full h-14 rounded-xl border-2 border-slate-200 focus:border-brand px-4 text-lg mb-4" />
        <label className="block text-base font-semibold text-ink mb-2">Mot de passe</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full h-14 rounded-xl border-2 border-slate-200 focus:border-brand px-4 text-lg mb-6" />
        <Button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full h-14 rounded-full bg-brand hover:bg-brand-hover text-white font-bold text-lg">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
        </Button>
      </form>
    </div>
  );
};

export default AdminLogin;
